import ErrorMessage from "components/common/ErrorMessage";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import { Select } from "components/common/Select";
import ReportingTable from "components/dashboard/ReportingTable";
import { fetchDashboardAppointments, downloadDashboardAppointmentsCSV, fetchReportStats } from "slices/dashboardSlice";
import { DashboardSelector } from "slices/dashboardSlice";
import { fetchLanguages } from "slices/languageSlice";
import { languageSelector } from "slices/languageSlice";
import { setError } from "slices/dashboardSlice";
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import FullPageLoader from "components/common/FullPageLoader";
import { usePermissions } from "layouts/Admin";
import { fetchFacilitiesDirect, fetchFacilities } from "slices/facilitiesSlice";
import { facilitiesSelector } from "slices/facilitiesSlice";
import { fetchVendors } from "slices/vendorSlice";

const DatesInputs = (({ control, errors }) => {
  const startDateRef = React.useRef(null);
  const endDateRef = React.useRef(null);

  return (
    <>
      <div className="row-primary">
        <h2>Start Date*</h2>
        <Controller
          name="start_date"
          control={control}
          render={({ field }) =>
            <div className="input-image basic_bases">
              <input ref={startDateRef} id='start_date' type="date" name='start_date' placeholder='Start Date'
                {...field}
                value={moment(field.value).format('YYYY-MM-DD')}
                onChange={(e) => {
                  const dateString = moment(e.target.value).format('YYYY/MM/DD')
                  field.onChange(dateString)
                }}
              />
              <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />

            </div>
          } />
        {errors.start_date && <ErrorMessage text={errors.start_date.message} />}
      </div>
      <div className="row-primary">
        <h2>End Date*</h2>
        <Controller
          name="end_date"
          control={control}
          render={({ field }) =>
            <div className="input-image basic_bases">
              <input ref={endDateRef} type="date" name='end_date' placeholder='End Date'
                {...field}
                value={moment(field.value).format('YYYY-MM-DD')}
                onChange={(e) => {
                  const dateString = moment(e.target.value).format('YYYY/MM/DD')
                  field.onChange(dateString)
                }}
              />
              <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />
            </div>
          } />
        {errors.end_date && <ErrorMessage text={errors.end_date.message} />}
      </div>
    </>
  )
});

function Reporting() {
  const { checkPermission } = usePermissions()
  const dispatch = useDispatch()
  const { dashboard, reportStats, last_page: totalPages, loader, total } = useSelector(DashboardSelector);
  const { language: languages } = useSelector(languageSelector);
  const { facilities } = useSelector(facilitiesSelector);

  const defaultValues = {
    status: 'all',
    start_date: moment().format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
    facility_id: '',
    vendor_id: '',
    language_id: '',
  };

  const { clearErrors, handleSubmit, watch, formState: { errors }, control, setValue, setError: setErrors, reset, } = useForm({
    defaultValues: defaultValues
  });

  const [statusValue, setStatusValue] = React.useState('all');
  const [filterKey, setFilterKey] = useState(0);

  const watchedValues = watch(['start_date', 'end_date', 'language_id', 'facility_id', 'vendor_id', 'status']);
  const [start_date, end_date, language_id, facility_id, vendor_id, status] = watchedValues;

  const paginationParams = React.useMemo(() => ({
    start_date: start_date ? moment(start_date).format('YYYY-MM-DD') : undefined,
    end_date: end_date ? moment(end_date).format('YYYY-MM-DD') : undefined,
    language_id,
    facility_id,
    vendor_id,
    status: status === 'all' ? "" : status
  }), [start_date, end_date, language_id, facility_id, vendor_id, status]);

  // Filter States
  const [filteredFacilities, setFilteredFacilities] = useState(null);
  const [filteredVendors, setFilteredVendors] = useState(null);
  const [filteredLanguages, setFilteredLanguages] = useState(null);

  useEffect(() => {
    // Initial fetch
    const initParams = { pageLength: 10, ...defaultValues, sortBy: "id", sortDirection: "desc" };
    dispatch(fetchDashboardAppointments(1, initParams));
    dispatch(fetchReportStats({
      start_date: moment(defaultValues.start_date).format('YYYY-MM-DD'),
      end_date: moment(defaultValues.end_date).format('YYYY-MM-DD'),
    }));
  }, [])


  const onSubmit = (data) => {
    let startDate = moment(data.start_date).format('YYYY-MM-DD');
    let endDate = moment(data.end_date).format('YYYY-MM-DD');
    if (startDate > endDate) {
      setErrors('end_date', { message: 'End Date must be greater than Start Date' })
      return;
    }

    console.log(data.status, 'asasasasassasasssasasas');

    const params = {
      start_date: startDate,
      end_date: endDate,
      status: data.status === 'all' ? '' : data.status,
      facility_id: data.facility_id,
      vendor_id: data.vendor_id,
      language_id: data.language_id,
      pageLength: 10,
      sortBy: "id",
      sortDirection: "desc"
    };

    console.log(params.status, 'asasasasassasasssasasas');

    dispatch(fetchDashboardAppointments(1, params));
    dispatch(fetchReportStats({
      start_date: startDate,
      end_date: endDate,
      status: data.status === 'all' ? '' : data.status,
      facility_id: data.facility_id,
      vendor_id: data.vendor_id,
      language_id: data.language_id,
    }));
    setFilterKey(prev => prev + 1);
    clearErrors();
  }

  // #region Facility dropdown
  const filteredFacilitiesLoadOptions = React.useCallback(async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchFacilities(page, { pageLength: 20, sortBy: "name", sortDirection: "asc", search: inputValue }, true, true));
    return {
      options: result?.data?.map((val) => ({ value: val.id, label: val.facility_name || val.name || "" })) || [],
      hasMore: page < Number(result?.last_page),
      additional: { page: page + 1 },
    };
  }, [dispatch]);
  // #endregion

  // #region Vendor dropdown
  const filteredVendorsLoadOptions = React.useCallback(async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchVendors(page, { pageLength: 20, sortBy: "name", sortDirection: "asc", search: inputValue }, true, true));
    return {
      options: result?.data?.map((val) => ({ value: val.id, label: val.name || "" })) || [],
      hasMore: page < Number(result?.last_page),
      additional: { page: page + 1 },
    };
  }, [dispatch]);
  // #endregion

  // #region Language dropdown
  const filteredLanguagesLoadOptions = React.useCallback(async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "name", sortDirection: "asc", search: inputValue }, true, true));
    return {
      options: result?.data?.map((val) => ({ value: val.id, label: val.name || "" })) || [],
      hasMore: page < Number(result?.last_page),
      additional: { page: page + 1 },
    };
  }, [dispatch]);
  // #endregion

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'open', label: 'Open' },
    { value: 'pending', label: 'Pending' },
    { value: 'assigned', label: 'Assigned' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'cnc', label: 'CNC' },
    { value: 'dnc', label: 'DNC' },
    { value: 'declined', label: 'Declined' },
    { value: 'vendor_cancelled', label: 'Vendor Cancelled' },
    { value: 'vendor_declined', label: 'Vendor Declined' },
  ];

  const handleResetFields = () => {
    setValue("start_date", moment().format('YYYY-MM-DD'));
    setValue("end_date", moment().format('YYYY-MM-DD'));
    setValue("language_id", "");
    setValue("vendor_id", "");
    setValue("facility_id", "");
    setValue("status", "all");
    setFilteredFacilities(null);
    setFilteredVendors(null);
    setFilteredLanguages(null);
    dispatch(fetchDashboardAppointments(1, { pageLength: 10, ...defaultValues, sortBy: "id", sortDirection: "desc" }));
    dispatch(fetchReportStats({
      start_date: moment().format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
    }));
    setFilterKey(prev => prev + 1);
    clearErrors()
  };


  return (
    <>
      <div className="content">
        {loader && <FullPageLoader />}
        <div className="row_main_head">
          <h2 className="main_heading">Request Fullfillment and Patient Coverage</h2>
        </div>
        <div className="card_table">
          <form className="search_form_ad" onSubmit={handleSubmit(onSubmit)}>
            <div className="row-primary dahboard_filter">
              <DatesInputs control={control} errors={errors} />

              <div className="row-primary">
                <h2>Facility</h2>
                <Controller
                  name="facility_id"
                  control={control}
                  render={({ field }) =>
                    <div className="basic_bases">
                      <AsyncPaginate
                        menuPlacement='auto'
                        styles={{ ...selectCustomStyles }}
                        debounceTimeout={300}
                        value={filteredFacilities}
                        loadOptions={filteredFacilitiesLoadOptions}
                        isClearable
                        onChange={(obj) => {
                          setFilteredFacilities(obj);
                          field.onChange(obj?.value);
                        }}
                        additional={{ page: 1 }}
                      />
                    </div>
                  }
                />
              </div>

              <div className="row-primary">
                <h2>Vendor</h2>
                <Controller
                  name="vendor_id"
                  control={control}
                  render={({ field }) =>
                    <div className="basic_bases">
                      <AsyncPaginate
                        menuPlacement='auto'
                        styles={{ ...selectCustomStyles }}
                        debounceTimeout={300}
                        value={filteredVendors}
                        loadOptions={filteredVendorsLoadOptions}
                        isClearable
                        onChange={(obj) => {
                          setFilteredVendors(obj);
                          field.onChange(obj?.value);
                        }}
                        additional={{ page: 1 }}
                      />
                    </div>
                  }
                />
              </div>

              <div className="row-primary">
                <h2>Language</h2>
                <Controller
                  name="language_id"
                  control={control}
                  render={({ field }) =>
                    <div className="basic_bases">
                      <AsyncPaginate
                        menuPlacement='auto'
                        styles={{ ...selectCustomStyles }}
                        debounceTimeout={300}
                        value={filteredLanguages}
                        loadOptions={filteredLanguagesLoadOptions}
                        isClearable
                        onChange={(obj) => {
                          setFilteredLanguages(obj);
                          field.onChange(obj?.value);
                        }}
                        additional={{ page: 1 }}
                      />
                    </div>
                  }
                />
              </div>

              <div className="row-primary">
                <h2>Status</h2>
                <Controller
                  name="status"
                  control={control}
                  render={({ field }) =>
                    <div className="basic_bases">
                      <Select
                        name="status"
                        options={statusOptions}
                        {...field}
                        value={field.value ? statusOptions.find((opt) => field.value == opt.value) : ""}
                      />
                    </div>
                  }
                />
              </div>
            </div>

            <div className="row-primary btns_area row_10">
              <SubmitButton handleSubmit={handleSubmit(onSubmit)} buttonType="button" btnText="Filter" className={'green'} />
              <SubmitButton buttonType="button" className={'lightBlue'} btnText="Reset" handleSubmit={handleResetFields} />
              <button
                type="button"
                style={{ marginLeft: 'auto' }}
                className="main_button"
                onClick={() => dispatch(downloadDashboardAppointmentsCSV(paginationParams))}
              >
                Download CSV
              </button>
            </div>

            <div className="col-12" style={{ display: 'flex', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' }}>
              <div className="report-stat-card">
                <span className="report-stat-label">Total Requests</span>
                <span className="report-stat-value">{reportStats?.total_requests ?? 0}</span>
              </div>
              <div className="report-stat-card">
                <span className="report-stat-label">Covered Requests</span>
                <span className="report-stat-value" style={{ color: '#22c55e' }}>{reportStats?.covered_requests ?? 0}</span>
              </div>
              <div className="report-stat-card">
                <span className="report-stat-label">Uncovered Requests</span>
                <span className="report-stat-value" style={{ color: '#ef4444' }}>{reportStats?.uncovered_requests ?? 0}</span>
              </div>
              <div className="report-stat-card">
                <span className="report-stat-label">Avg. Time to Cover</span>
                <span className="report-stat-value">{reportStats?.avg_time_to_cover ?? 0} mins</span>
              </div>
            </div>

            <div className="col-12">
              <ReportingTable data={dashboard?.appointments || []} paginationParams={paginationParams} filterKey={filterKey} />
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Reporting;